import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {AppNotification} from "../model/AppNotification";


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  messageNotificationChange: Subject<AppNotification> = new Subject<AppNotification>();

  private defaultLifetime = 6000;

  constructor() {
  }

  messageNotifyError(message: string): void {
    this.messageNotify('error', message, this.defaultLifetime);
  }

  messageNotifyWarn(message: string): void {
    this.messageNotify('warn', message, this.defaultLifetime);
  }

  messageNotifySuccess(message: string): void {
    this.messageNotify('success', message, this.defaultLifetime);

  }

  messageNotifyInfo(message: string): void {
    this.messageNotify('info', message, this.defaultLifetime);
  }

  messageNotify(severity: string, message: string, lifetime: number = this.defaultLifetime): void {
    this.messageNotificationChange.next({ severity, message, lifetime });
  }
}
